<template>
  <div class="project-changeUpgrade-dialog">
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <!-- 表格 -->
        <div class="product-wrap">
          <div class="search-hd">
            <el-form :inline="true" @submit.native.prevent style="padding-top: 0">
              <el-radio-group v-model="formSearch.type" @change="getTableList">
                <el-radio-button :label="item.value" v-for="(item, index) in eventTypeData" :key="index">{{ item.label }}</el-radio-button>
              </el-radio-group>
              <el-form-item style="float: right">
                <search-input :placeholder="$t('report_robotLog_event_dialog.sjdmV3dmV4dm')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" @submit.native.prevent style="padding-top: 16px;">
              <el-form-item>
                <p>{{ $t('report_robotLog_event_dialog.ji_lu_shi_jian') }}：{{model.timeMsg}}</p>
              </el-form-item>
            </el-form>
          </div>
          <div class="table-bd">
            <custom-table
              ref="table"
              index
              v-model="selectRow"
              :data="resourceList"
              :loading="isLoading"
              tableCode="robot_workLog_event"
              @filter="filterChange"
              @sort="sortChange"
              height="500px"
            ></custom-table>
          </div>
          <div class="table-page">
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>

      </div>

    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  components: { },
  mixins: [dialogMixins],
  data() {
    return {
      isLoading: false,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
        bodyNum: '',
        workRunId: '',
        eventCode: '',
        isAssist: '',
        type: '',
        startDate: '',
        endDate: '',
      },
      componentValue: '',
      totalRows: null,
      selectRow: {},
      fwList: [],
      resourceList: [],
    };
  },
  computed: {
    eventTypeData() {
      return [
        {
          label: this.$t('Common.com_all'),
          value: '0',
        },
        {
          label: this.$t('report_robotLog_event_dialog.zan_ting'),
          value: '1',
        },
        {
          label: this.$t('report_robotLog_event_dialog.fu_zhu'),
          value: '2',
        },
        {
          label: this.$t('report_robotLog_event_dialog.peng_zhuang'),
          value: '3',
        },
        {
          label: this.$t('report_robotLog_event_dialog.xuan_ya'),
          value: '4',
        },
        {
          label: this.$t('report_robotLog_event_dialog.duo_xuan_ya'),
          value: '5',
        },

      ];
    },


  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.formSearch.bodyNum = this.model.data.bodyNum;
    this.formSearch.workRunId = this.model.data.workRunId;
    this.formSearch.type = this.model.data.type;
    this.formSearch.startDate = this.model.data.startDate;
    this.formSearch.endDate = this.model.data.endDate;
    // this.formSearch.eventCode = this.model.data.eventCode;
    // if (this.formSearch.isAssist) {
    //   this.eventType = this.formSearch.isAssist;
    // } else {
    //   this.eventType = this.formSearch.eventCode;
    // }
    this.initDialog();
    this.getTableList();

  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },

    // 获取关联列表
    getTableList: function () {
      this.isLoading = true;
      // if (this.eventType === 0) {
      //   // 全部
      //   delete this.formSearch.isAssist;
      //   this.formSearch.eventCode = '';
      // } else if (this.eventType === 1) {
      //   // 辅助
      //   delete this.formSearch.eventCode;
      //   this.formSearch.isAssist = 1;
      // } else if (this.eventType !== 1) {
      //   // 事件代号[碰撞：mch37，悬崖：mch38]
      //   delete this.formSearch.isAssist;
      //   this.formSearch.eventCode = this.eventType;
      // }
      this.$getJSON(apis.workRunRobotEventPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.resourceList = res.data ? res.data.list : [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
.project-changeUpgrade-dialog {
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 16.6%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }
  }
}
</style>
